import Icon from '../components/Icon';

const City = Icon(
  'city',
  <>
    <path d="M9.75 9.75a.75.75 0 0 1 .75.75V12A.75.75 0 0 1 9 12v-1.5a.75.75 0 0 1 .75-.75M7.5 10.5a.75.75 0 0 0-1.5 0V12a.75.75 0 0 0 1.5 0zM6.75 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75M10.5 15.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z" />
    <path
      fillRule="evenodd"
      d="M12.707 1.678a1.52 1.52 0 0 0-1.54.075l-7.485 4.99-.014.01A1.5 1.5 0 0 0 3 8.002V19.5H1.5a.75.75 0 0 0 0 1.5h21a.75.75 0 0 0 0-1.5H21V9.25c0-.965-.781-1.75-1.749-1.75H13.5V3c0-.543-.314-1.066-.793-1.322M12 19.5H4.5V8L12 3zm3.75 0H13.5v-4.25h.75a1.5 1.5 0 0 1 1.5 1.5zm1.5 0v-2.75a3 3 0 0 0-3-3h-.75V9h5.751c.137 0 .249.11.249.25V19.5z"
      clipRule="evenodd"
    />
  </>
);

export default City;
